// © Thibault Sabathier, 2026. Tous droits réservés.
// frontend/src/utils/buildInfo.js
//
// Identité du build RÉELLEMENT chargé dans le navigateur ou la PWA. `__APP_BUILD__` est injecté
// à la compilation par vite.config.mjs (commit git + horodatage) : il est figé dans le bundle,
// donc il dit quelle version tourne, pas quelle version est déployée. Utile pour diagnostiquer
// une PWA qui garderait un ancien build en cache.

/* global __APP_BUILD__ */

const UNKNOWN = { version: 'dev', builtAt: null }

/** @returns {{version: string, builtAt: (string|null)}} */
export const getBuildInfo = () => {
  try {
    if (typeof __APP_BUILD__ !== 'undefined' && __APP_BUILD__ && __APP_BUILD__.version) {
      return { version: String(__APP_BUILD__.version), builtAt: __APP_BUILD__.builtAt || null }
    }
  } catch (e) {
    // bundle sans injection (tests, outils) : on retombe sur « dev »
  }
  return UNKNOWN
}

// Un identifiant git complet (40 car.) est raccourci : le CI/VPS peut fournir le SHA entier.
const shorten = (version) => (/^[0-9a-f]{12,40}$/i.test(version) ? version.slice(0, 8) : version)

/** « 484e6db4 · 2026-10-13 08:43 UTC » (sans libellé traduisible : lisible dans toutes les langues). */
export const formatBuildLabel = (info = getBuildInfo()) => {
  const { version: rawVersion, builtAt } = info || UNKNOWN
  const version = shorten(String(rawVersion))
  const d = builtAt ? new Date(builtAt) : null
  if (!d || Number.isNaN(d.getTime())) return version
  return `${version} · ${d.toISOString().slice(0, 16).replace('T', ' ')} UTC`
}
